import { useAppSelector } from 'app';
import { selectAppDevice } from 'slice';
import { DEVICES } from 'utils';

import CollaboratorCreatePageContentDesktop from './ContentDesktop';
import CollaboratorCreatePageContentMobile from './ContentMobile';

interface CollaboratorCreatePageContentProps {
  handleSubmitStep: (e: number) => void;
  handleNextStep: () => any;
  ListStep: any[];
  isSubmitting: boolean;
  currentTab: number;
  handleChangeCurrentStep: (e: number) => void;
}

const Content = ({
  handleSubmitStep,
  handleNextStep,
  ListStep,
  isSubmitting,
  currentTab,
  handleChangeCurrentStep,
}: CollaboratorCreatePageContentProps): JSX.Element => {
  const appDevice = useAppSelector(selectAppDevice);
  const props = {
    handleSubmitStep,
    handleNextStep,
    ListStep,
    isSubmitting,
    currentTab,
    handleChangeCurrentStep,
  };
  const renderElements = {
    [DEVICES.DESKTOP]: <CollaboratorCreatePageContentDesktop {...props} />,
    [DEVICES.MOBILE]: <CollaboratorCreatePageContentMobile {...props} />,
    [DEVICES.TABLET]: <CollaboratorCreatePageContentMobile {...props} />,
  };
  return renderElements[appDevice.device];
};

export default Content;
